import type { Correction } from '@kimuno/api-sdk';
import immutable from 'object-path-immutable';

import { LOGOUT, type LogoutAction } from '../actions/auth.actionTypes';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
	type CorrectionsActionTypes,
	CREATE_CORRECTION,
	GET_CORRECTION,
	UPDATE_CORRECTION,
} from '../actions/corrections.actionTypes';
import type { StoreItem } from '.';

export interface CorrectionsState {
	byId: Record<string, StoreItem<Correction>>;
}

const initialState: CorrectionsState = { byId: {} };

// A re-fetch keeps the previous data visible while LOADING, so a poll tick never
// blanks the screen; only the first fetch of an id has no data to keep.
const corrections = (
	// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
	state = initialState,
	action: CorrectionsActionTypes | LogoutAction
): CorrectionsState => {
	switch (action.type) {
		case LOGOUT.SUCCESS:
			return initialState;

		case CREATE_CORRECTION.SUCCESS:
			return immutable(state)
				.set(['byId', action.result.id], { data: action.result, status: AsyncActionStatus.READY })
				.value();

		case GET_CORRECTION.START:
		case UPDATE_CORRECTION.START:
			return immutable(state)
				.set(['byId', action.payload.correctionId, 'status'], AsyncActionStatus.LOADING)
				.value();

		case GET_CORRECTION.SUCCESS:
		case UPDATE_CORRECTION.SUCCESS:
			return immutable(state)
				.set(['byId', action.payload.correctionId], {
					data: action.result,
					status: AsyncActionStatus.READY,
				})
				.value();

		case GET_CORRECTION.ERROR:
		case UPDATE_CORRECTION.ERROR:
			return immutable(state)
				.set(['byId', action.payload.correctionId, 'status'], AsyncActionStatus.ERROR)
				.set(['byId', action.payload.correctionId, 'error'], action.error.message)
				.value();

		default:
			return state;
	}
};

export default corrections;
